// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCP2QVESqjOkj-Y0b8o5VbYoAoWVpTHFj0",
  authDomain: "pacificrov-7015f.firebaseapp.com",
  projectId: "pacificrov-7015f",
  storageBucket: "pacificrov-7015f.appspot.com",
  messagingSenderId: "122722750280",
  appId: "1:122722750280:web:823de74935e1692a526d7d",
  measurementId: "G-2KT7765LV7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

const authenticate = getAuth(app);

export {db, authenticate};
